export const API_GET_SEARCH_KEEPER_ENDPOINT_LOGS = "API_GET_SEARCH_KEEPER_ENDPOINT_LOGS"
export const RESET_SEARCH_KEEPER_LOGS = "RESET_SEARCH_KEEPER_LOGS"
export const RESET_SEARCH_KEEPER_LOGS_FOCUS = "RESET_SEARCH_KEEPER_LOGS_FOCUS"
export const API_GET_ANALYZED_SEARCH_LOG = "API_GET_ANALYZED_SEARCH_LOG"
export const API_GET_SEARCH_LOG_CSV = "API_GET_SEARCH_LOG_CSV"
